const addStylesheet = css => {
  const style = document.createElement('style');
  document.head.appendChild(style);
  const sheet = style.sheet;
  sheet.insertRule(css);
};

export default addStylesheet;
